import React from 'react';
import './Page.css';
import Food from './Food';
import { Link, Outlet } from 'react-router-dom';
import Footer from './Footer';

const Page = () => {
  return (
    <div className="page-wrapper">
      <nav className="nav-container">
        <div className="nav-left">
          <img src="./Images/Lorevial.png" alt="Lorevial Icon" className="nav-icon" />
        </div>
        <div className="nav-right">
             <div className="dropdown">
            <button className="dropbtn">Products ▾</button>
            <div className="dropdown-content">
              <Link to="/Food">Ingredient Lore</Link>
              <Link to="/NutriLore">Nutrient Lore</Link>
              <Link to="/Theraphy" className="nav-link">Theraphy</Link>
          <Link to="/Breathing" className="nav-link">Breathing</Link>
          <Link to="/ImmuneSystem">Immune System Health</Link>
            </div>
          </div>
         
          <Link to="https://lorevial.in" className="nav-link">Home</Link>
         
           
           <Link to="/about-us" className="nav-link">About Us</Link>

        </div>
      </nav>

      <main className="main-content">
        <Outlet />
      </main>
      <Footer/>
    </div>
  );
};

export default Page;
